import _ from 'underscore';
import { useEffect, useRef, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { STEP_STATES, useWizardService } from '@bingads-webui-react/wizard-core';
import { WizardPerfMarkerContext } from './utils';

export const StepPerfMarker = ({ parentPerfMarker, markerName }) => {
  const stepPerfMarkerRef = useRef(null);
  const { register = _.noop, unregister = _.noop } = useContext(WizardPerfMarkerContext);

  const { state } = useWizardService();
  const currentStepFullState = state.toStrings()[1] || '';
  const currentStepState = currentStepFullState.split('.')[1];

  useEffect(() => {
    if (parentPerfMarker) {
      stepPerfMarkerRef.current = parentPerfMarker.createChild(markerName, { autoEnd: false });
      register();
    }

    return () => {
      stepPerfMarkerRef.current = null;
      unregister();
    };
  }, [markerName, parentPerfMarker, register, unregister]);

  const handleStepStateChange = useCallback(
    () => {
      if (!stepPerfMarkerRef.current) {
        return;
      }

      if (currentStepState === STEP_STATES.FETCHING) {
        stepPerfMarkerRef.current.willFetchFile();
      } else if (currentStepState === STEP_STATES.LOADING) {
        stepPerfMarkerRef.current.willInit();
      } else if (currentStepState === STEP_STATES.ACTIVE) {
        stepPerfMarkerRef.current.willRender();
        setTimeout(() => {
          stepPerfMarkerRef.current && stepPerfMarkerRef.current.done();
        }, 0);
      }
    },
    [currentStepState]
  );

  useEffect(
    () => {
      handleStepStateChange();
    },
    [handleStepStateChange]
  );

  return null;
};

StepPerfMarker.propTypes = {
  markerName: PropTypes.string.isRequired,
  parentPerfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
};
